import { Trans } from "./Trans";


function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}


export class ObjViewer {

    private trans: Trans;
    private static mapElToObj = new Map<string, ObjViewer>();

    public static getInstance(element: HTMLElement): ObjViewer {
        if (element.hasAttribute('data-tul-csv-table-objviewer-uuid')) {
            let key = element.getAttribute('data-tul-csv-table-objviewer-uuid') + "";
            if (this.mapElToObj.has(key)) {
                let v = this.mapElToObj.get(key);
                if (v != undefined && v != null) {
                    return v;
                }
                this.mapElToObj.delete(key)
            }

        }
        let new_uuid: string = "";
        do {
            new_uuid = generateUUID();
        } while (new_uuid.length <= 0 || this.mapElToObj.has(new_uuid))

        let o = new ObjViewer(element, new_uuid);
        element.setAttribute('data-tul-csv-table-objviewer-uuid', new_uuid);
        this.mapElToObj.set(new_uuid, o);
        return o;
    }
    private _data: Array<{ [key: string]: string }>;
    private itemsDescription: HTMLElement;
    private itemsContainer: HTMLElement;
    // private preTypes: HTMLElement;
    private optionsContainer: HTMLFormElement

    private get skipColumns(): Array<string> {
        if (!this.element.hasAttribute('data-tul-csv-table-objviewer-skip-columns')) {
            this.element.setAttribute('data-tul-csv-table-objviewer-skip-columns', "");
            return [];
        }
        let attrValue = this.element.getAttribute('data-tul-csv-table-objviewer-skip-columns') + "".trim();
        if (attrValue.length <= 0) {
            return [];
        }
        let values: Array<string> = [];
        try {
            let json = JSON.parse(attrValue);
            if (Array.isArray(json)) {
                values = json.map(v => v + "");
            } else {
                values = [attrValue];
            }
        } catch (e) {
            attrValue.split(",").forEach(v => {
                if (v.trim().length > 0) {
                    values.push(v.trim());
                }
            })
        }

        // Make unique
        values = Array.from(new Set(values));

        values = values.map(v => v.trim())
            .filter(v => v.length > 0)
            .map(v => v.toLowerCase())
            // Replace multiple spaces with single space
            .map(v => v.replace(/\s+/g, ' '));

        values = Array.from(new Set(values));
        return values;
    }
    private filterOutSkippedColumns(columns: Array<string>): Array<string> {
        let skipColumns = this.skipColumns;
        if (skipColumns.length <= 0) {
            return columns;
        }

        columns = columns.filter(c => {
            let cNormalized = c.trim().toLowerCase().replace(/\s+/g, ' ');
            return !skipColumns.includes(cNormalized);
        })
        return columns;
    }

    private constructor(private element: HTMLElement, private uuid: string) {
        this.trans = Trans.getInstance();
        this._data = [];
        // this.preTypes = document.createElement('pre');
        this.optionsContainer = document.createElement("form");

        this.itemsDescription = document.createElement('p');
        this.itemsDescription.classList.add("objs-description");
        this.itemsContainer = document.createElement('div');
        this.element.appendChild(this.optionsContainer);
        // this.element.appendChild(this.preTypes);
        this.element.appendChild(this.itemsDescription);
        this.element.appendChild(this.itemsContainer);
    }

    private _selected_options = new Map<string, string>();
    public setOption(key: string, value: string) {
        value = value.trim();
        if (value.length <= 0) {
            this._selected_options.delete(key);
        } else {
            this._selected_options.set(key, value);
        }
        this.refresh();
    }
    private get selected_options(): Map<string, string> {
        return this._selected_options;
    }
    private _options: { [key: string]: Array<string> } = {}
    private set options(value: { [key: string]: Array<string> }) {
        this._options = JSON.parse(JSON.stringify(value));
        this.refresh_options();
    }
    private get options(): { [key: string]: Array<string> } {
        return JSON.parse(JSON.stringify(this._options));
    }
    /**
     * Regenerates form for options based on this.options
     */
    private refresh_options() {
        this.optionsContainer.innerHTML = "";
        const options = this.options;
        const allowedOptKeys = this.filterOutSkippedColumns(Object.keys(options));
        Object.keys(options).forEach(optKey => {
            if (!allowedOptKeys.includes(optKey)) {
                console.info(`Column "${optKey}" is skipped, because it is in skip-columns list.`);
                return;
            }
            let optValues = options[optKey];
            if (optValues == undefined || optValues.length <= 1) {
                return;
            }
            let fieldset = document.createElement('fieldset');
            let text = document.createElement('label');
            text.textContent = optKey;
            fieldset.appendChild(text);
            let to_mouch_opt_for_select = false;
            if (optValues.length > 50) {
                to_mouch_opt_for_select = true;
            }
            let optValuesNumeric: Array<number> = optValues.map(o => o.trim()).map(o => {
                if (o.length <= 0) {
                    return NaN;
                }
                if (/^-?([ ]{1,})?\d+$/.test(o) || /^-?([ ]{1,})?\d+[,.]\d+$/.test(o)) {
                    return parseFloat(o.replace(",", "."));
                }
                return NaN;
            });
            let all_options_is_numeric = optValuesNumeric.every(o => !isNaN(o));
            if (all_options_is_numeric) console.info("All options is numeric " + optKey + ", so skipping select and using input for filtering.");
            // let minOptValue = Math.min(...optValuesNumeric.filter(o => !isNaN(o)));
            // let maxOptValue = Math.max(...optValuesNumeric.filter(o => !isNaN(o)));

            if (!all_options_is_numeric) {
                let tagInput = to_mouch_opt_for_select ? "input" : "select";
                let input = document.createElement(tagInput);
                input.setAttribute('data-key', optKey);
                if (input.tagName.toUpperCase() == "SELECT") {
                    let oElDef = document.createElement('option');
                    oElDef.textContent = this.trans.t("-- All --");
                    oElDef.value = "";
                    input.appendChild(oElDef);
                    optValues.forEach(o => {
                        if ((o + "").trim().length <= 0) {
                            return;
                        }
                        let oEl = document.createElement('option');
                        oEl.textContent = o;
                        oEl.value = o;
                        input.appendChild(oEl);
                    })
                } else if (input.tagName.toUpperCase() == "INPUT") {
                    text.textContent += " (" + this.trans.t("any word") + ")";
                }
                const refThis = this;
                input.addEventListener('change', function (ev) {
                    let key = (ev.currentTarget as HTMLElement).getAttribute('data-key') + "";
                    let tag = (ev.currentTarget as HTMLElement).tagName.toUpperCase();
                    let value = (ev.currentTarget as HTMLSelectElement || HTMLInputElement).value;
                    if (tag == "INPUT") {
                        value = "*" + value + "*";
                    }

                    refThis.setOption(key, value);
                })
                fieldset.appendChild(input);
                this.optionsContainer.appendChild(fieldset);
            }

        });
    }
    private refresh(): void {
        const displayed_data = this.displayed_data;

        let opt = this.options;
        if (Object.keys(opt).length <= 0) {
            // Regenerate options
            const addOption = function (column: string, value: string): void {
                if (!Object.keys(opt).includes(column)) {
                    opt[column] = [value];
                } else {
                    if (opt[column]?.includes(value)) {

                    } else {
                        opt[column]?.push(value)
                    }
                }
            }
            this.data.forEach(i => {
                Object.keys(i).forEach(columnName => {
                    let v = i[columnName];
                    if (v != undefined) {
                        addOption(columnName, v)
                    }
                })
            })
            if (JSON.stringify(opt) != JSON.stringify(this.options)) {
                this.options = opt;
            }
            // End of regeneration options
        }

        // this.preTypes.textContent = JSON.stringify({}, null, 2)

        // this.itemsContainer.childNodes.forEach(i => i.remove());

        if (this.is_not_empty_form) {
            this.itemsDescription.textContent = this.trans.t(`Found %number records`, { number: displayed_data.length });
        } else {
            this.itemsDescription.textContent = "";
        }
        this.itemsContainer.innerHTML = "";

        if (this.is_not_empty_form) {
            displayed_data.forEach(i => {
                let itemEl = document.createElement('div');
                itemEl.classList.add("objs-item");
                let list = document.createElement('ul');
                itemEl.appendChild(list);
                Object.keys(i).map(key => {
                    let value = i[key];
                    return `<span class="obj-prop-key">${key}</span> - <span class="obj-prop-value">${value}</span>`
                }).forEach(text => {
                    let li = document.createElement('li');
                    li.innerHTML = text;
                    list.appendChild(li)
                });
                this.itemsContainer.appendChild(itemEl);
            })
        } else {
            let itemEl = document.createElement('div');
            itemEl.textContent = this.trans.t("Please select at least one option to see the results.");
            itemEl.classList.add("first-you-need-input");
            this.itemsContainer.appendChild(itemEl);
        }

    }

    public set data(data: Array<{ [key: string]: string }>) {
        this._data = data;
        this.refresh();
    }
    public get data(): Array<{ [key: string]: string }> {
        return this._data;
    }

    private get displayed_data(): Array<{ [key: string]: string }> {
        let data = this.data;
        let selected_options = this.selected_options;
        selected_options.entries().forEach(entry => {
            let key = entry[0];
            let value = entry[1];
            let operator: "equal" | "contain" = "equal";
            if (value.startsWith("*") && value.endsWith("*")) {
                operator = "contain";
                value = value.substring(1);
                value = value.substring(0, value.length - 1);
            }
            switch (operator) {
                case 'equal':
                    data = data.filter(item => {
                        let itemValue = item[key];
                        if (itemValue == undefined) { return false; }
                        return itemValue == value;
                    });
                    break;
                case 'contain':
                    value = value.toLowerCase();
                    data = data.filter(item => {
                        let itemValue = item[key];
                        if (itemValue == undefined) { return false; }
                        return itemValue.toLowerCase().includes(value);
                    });
                    break;
            }
        })
        return data;
    }

    private get is_not_empty_form(): boolean {
        return this.selected_options.size > 0;
    }


}